enum Direction {
  Up = 1,
  Down = 100,
}

export default Direction;
